(function() {
    'use strict';
    
a3_cabin_reports.controller('AssfSignatureCtrl', AssfSignatureCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name AssfSignatureCtrl
    * @description 
    *  Manages the Assf Signature Modal View
    * @ngInject
    */
function AssfSignatureCtrl($scope, $uibModalInstance,  reportData, signatureType)  {
     $scope.assfReport = reportData;
      $scope.signatureField = 
      signatureType.charAt(0).toLowerCase() + signatureType.slice(1) + 'Signature';
    
   $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.save = function() {
      $uibModalInstance.close();
    };
	}

})();
